import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSpinnerService } from '../services/global-spinner.service';
import { LoginService } from '../login/login.service';
import { SnackBarService } from '../services/snackbar.service';
import { finalize } from 'rxjs/operators';
import { ServerErrorUtils } from 'src/app/shared/utils/server-error-utils';

@Component({
  selector: 'ctv-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  public userEmail: string;

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly snackBarService: SnackBarService,
    private readonly globalSpinnerService: GlobalSpinnerService
  ){

  }


  public forgotPasswordMail() {
    this.globalSpinnerService.showLoader();
    this.loginService.forgotPasswordMail(this.userEmail)
    .pipe(
      finalize(() => this.globalSpinnerService.hideLoader())
    )
    .subscribe(
      (data) => {
        this.snackBarService.success('Password reset link sent to ' + this.userEmail);
      },
      (error) => {
        const messages = ServerErrorUtils.getValidationMessages(error);
        if (messages) {
          messages.forEach(m => this.snackBarService.error(m));
        } else {
          this.snackBarService.error('Error while trying to reset password.');
      }}
    );
  }

  public navigateToLogin(){
    this.router.navigate(['/login']);
  }
}
